import { useSiteActivationContext } from "../../hooks/site-activation-context";
import { css } from "@compiled/react";

import { useIntl } from "react-intl";

export const HelperText = () => {
    const { formatMessage } = useIntl();

    const { isWorkspaceProduct } = useSiteActivationContext();

    const text = isWorkspaceProduct
        ? formatMessage({
              id: "siteActivation.nameSite.inputWorkspaceNameHelperText",
              defaultMessage:
                  "This workspace name is just a suggestion. Feel free to change to something your team will recognize."
          })
        : formatMessage({
              id: "siteActivation.nameSite.inputSiteNameHelperText",
              defaultMessage:
                  "This site name is just a suggestion. Feel free to change to something your team will recognize."
          });

    return (
        <p id="site-name-helper" css={helperTextCss}>
            {text}
        </p>
    );
};

const helperTextCss = css({
    color: "inherit",
    fontSize: "0.75rem",
    lineHeight: 1.5,
    margin: "0.5rem 0 0"
});
